import { PLANS } from "./types/entities.js";
export const CAPABILITIES = [
    "reports.view",
    "reports.export",
    "scripts.inventory",
    "scripts.pages",
    // Payment pages on a site, the filters and alert scope that use them (task
    // 306). Enforced by the API, not only the dashboard.
    "pages.payment",
    // Script authorization (task 307): decisions with their justification and
    // history, the review queue and the script alert types. Built on payment
    // pages, so it starts on the same plan. Reading the inventory, decisions and
    // export is `scripts.inventory`, or any tenant that has made a decision, so a
    // downgrade never locks away evidence.
    "scripts.authorization",
    // SAML single sign-on against a tenant's own identity provider (task 348).
    // Enterprise only, and not Business: Descope caps SSO connections per
    // project — three on the free plan — so every connection is a real provider
    // cost, and a contract-priced plan is where that is a line item rather than
    // a margin surprise on a published price.
    "auth.sso",
];
const PLAN_CAPABILITIES = {
    free: ["reports.view", "reports.export"],
    team: ["reports.view", "reports.export", "scripts.inventory"],
    professional: [
        "reports.view",
        "reports.export",
        "scripts.inventory",
        "scripts.pages",
        "pages.payment",
        "scripts.authorization",
    ],
    business: [
        "reports.view",
        "reports.export",
        "scripts.inventory",
        "scripts.pages",
        "pages.payment",
        "scripts.authorization",
    ],
    // Every capability, always. A contract negotiates limits, not features:
    // per-tenant capability overrides are deliberately not a thing (task 345),
    // so an Enterprise tenant is defined by having all of them.
    enterprise: [
        "reports.view",
        "reports.export",
        "scripts.inventory",
        "scripts.pages",
        "pages.payment",
        "scripts.authorization",
        "auth.sso",
    ],
};
export function hasCapability(plan, capability) {
    return PLAN_CAPABILITIES[plan].includes(capability);
}
/**
 * The least plan that includes a capability: what a page names when it says
 * "on Professional" rather than showing a lock (ADR 013, principle 3).
 */
export function lowestPlanWith(capability) {
    const plan = PLANS.find((candidate) => hasCapability(candidate, capability));
    // Enterprise holds every capability, so there is always one.
    return plan ?? "enterprise";
}
//# sourceMappingURL=capabilities.js.map